// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1L0-P","load8":"Loader_load8__32Zgn"};